import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  notificationMenuAction,
  languageMenuAction,
  authMenuAction,
  pagesMenuAction,
  mailMenuAction,
  profileMenuAction,
  darkModeAction,
  darkHeaderAction,
  darkSidebarAction,
  darkMinSidebarAction
} from "../../actions/settingsAction";

class Header extends Component {

  UNSAFE_componentWillMount() {
    document.addEventListener("mousedown", this.hideLeftSidebarProxy, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.hideLeftSidebarProxy, false);
  }

  hideLeftSidebarProxy = (e) => {
    const {
      profileMenuAction,
      profileMenu
    } = this.props;
    if (!this.leftSidebar.contains(e.target) && profileMenu) {
      profileMenuAction(false);
    }
  };

  render() {
    const {
      fixNavbar,
      darkHeader,
      profileMenu,
      profileMenuAction,
      userProfile = {},
      studentProfile = {}
    } = this.props;

    const { isStudent, full_name: student_name = {} } = studentProfile;

    const { full_name = {}, profile_picture, profile_photo_url } = userProfile;
    const { first_name = '', middle_name = '', last_name = '' } = full_name;

    const { first_name: student_first_name = '' } = student_name;



    return (
      <div
        className={`section-body ${fixNavbar ? "sticky-top" : ""} ${darkHeader ? "top_dark" : ""}`}
        id="page_top"
      >
        <div className="container-fluid">
          <div className="page-header justify-content-end" style={{ display: "flex" }}>
            <div
              ref={(leftSidebar) => {
                this.leftSidebar = leftSidebar;
              }}
              className="right">
              <div className="notification d-flex">
                <div className={`dropdown d-flex${profileMenu ? " show" : ""}`}>
                  <span
                    className="chip ml-3"
                    onClick={() => profileMenuAction(!profileMenu)}
                    style={{cursor: "pointer", color: "black", fontSize: "large"}}
                  >
                    {isStudent ? <i className="fa fa-user-o avatar" style={{background: "none"}} aria-hidden="true"></i> : <img className="avatar" src={profile_photo_url || profile_picture} alt="" />}
                    {isStudent ? student_first_name : `${first_name} ${middle_name && middle_name !== '-' ? middle_name : ''} ${last_name}`}
                  </span>
                  <div
                    className={`dropdown-menu dropdown-menu-right dropdown-menu-arrow${profileMenu ? " show dProfile" : ""
                      }`}
                  >
                    {!isStudent && (
                      <Link className="dropdown-item" to="/viewUser">
                        <i className="dropdown-icon fe fe-user"></i> Profile
                      </Link>)}
                    <Link className="dropdown-item" to="/updatePassword">
                      <i className="dropdown-icon fa fa-key"></i> Change Password
                    </Link>
                    <div className="dropdown-divider"></div>
                    <span className="dropdown-item">
                      <i className="dropdown-icon fe fe-help-circle"></i> Need
                      help?
                    </span>
                    <Link className="dropdown-item" to="/login">
                      <i className="dropdown-icon fe fe-log-out"></i> Sign out
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  boxShadow: state.settings.isBoxShadow,
  profileMenu: state.settings.isProfileMenu,
  pagesMenu: state.settings.isPagesMenu,
  mailMenu: state.settings.isMailMenu,
  languageMenu: state.settings.isLanguageMenu,
  authMenu: state.settings.isAuthMenu,
  fixNavbar: state.settings.isFixNavbar,
  darkHeader: state.settings.isDarkHeader,
  notificationMenu: state.settings.isNotificationMenu,
  isDarkMode: state.settings.isDarkMode,
  isDarkHeader: state.settings.isDarkHeader,
  isDarkSidebar: state.settings.isDarkSidebar,
  isMinSidebar: state.settings.isMinSidebar,
  userProfile: state.authenticationReducer.userProfile,
  studentProfile: state.authenticationReducer.studentProfile
});

const mapDispatchToProps = (dispatch) => ({
  authMenuAction: (e) => dispatch(authMenuAction(e)),
  notificationMenuAction: (e) => dispatch(notificationMenuAction(e)),
  languageMenuAction: (e) => dispatch(languageMenuAction(e)),
  mailMenuAction: (e) => dispatch(mailMenuAction(e)),
  profileMenuAction: (e) => dispatch(profileMenuAction(e)),
  pagesMenuAction: (e) => dispatch(pagesMenuAction(e)),
  darkModeAction: (e) => dispatch(darkModeAction(e)),
  darkHeaderAction: (e) => dispatch(darkHeaderAction(e)),
  darkSidebarAction: (e) => dispatch(darkSidebarAction(e)),
  darkMinSidebarAction: (e) => dispatch(darkMinSidebarAction(e)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Header);
